
<template>
  <div class="container mt-2 surface-card" v-if="Rpt.topThree.length != 0">

    <div class="col-12" v-if="ShowEmailedToBanner == true">
      <Message severity="success" :life=5000 ref="successmsg">A copy of your report has been emailed to you</Message>
    </div>

    <Panel header="My Power Tools Results" class="surface-borde-1 shadow-1 mt-5">
      <div class="col-12 flex align-items-center justify-content-end" v-if="!IsExporting">
       
            <!--<h4>Power Tools Assessment&#8482; Result</h4>-->
            <Button label="Export" icon="pi pi-file-pdf" class="p-button p-button-outlined border-orange-600 text-orange-600" v-on:click="generateReport(event)" :disabled="IsExporting" />
      </div>

      <div class="row" v-if="!IsExporting">
        <div class="col-12">
          <Splitter class="mb-0" layout="vertical">
            <SplitterPanel class="flex align-items-center justify-content-center">
              <!--<h4>Power Tools Assessment&#8482; Result</h4>-->
              <h2><img src="https://mwiassets.blob.core.windows.net/logos/power-tools-assesment-2.png" height="100" /></h2>
            </SplitterPanel>
            </Splitter>
        </div>
      </div>

      <Divider align="center" v-if="!IsExporting">
        <div class="inline-flex align-items-center">
          <i class="pi pi-bolt mr-2" style="font-size: 1.5rem"></i>
          <b style="font-size: 1.5rem">My Power Cluster</b>
        </div>
      </Divider>

      <div class="col-12 mb-5 surface-card shadow-1" v-if="!IsExporting">
        <Splitter layout="vertical" style="border:none">
          <SplitterPanel style="border-top: none;">
            <div style="text-align:center" class="p-3 my-0">
              <Badge :value="Report.topThree[0].categoryName" :style="{'background-color':GetBackGroundColor(0), 'color':'white'}" size="large"></Badge>
              <apexchart type="radialBar" height="175" :options="SetGaugeOptions(GetBackGroundColor(0) ,Report.topThree[0].categoryPercentageScore, Report.topThree[0].categoryName)" :series="GetSeries(Report.topThree[0].categoryPercentageScore)" :key="10"></apexchart>
            </div>
            <p class="px-3">{{Report.topThree[0].categoryDescription}}</p>
            <Divider align="center">
              <div class="inline-flex align-items-center">
                <i class="pi pi-briefcase mr-2" style="font-size: 1.5rem"></i>
                <b style="font-size: 1.5rem">Professional Expression</b>
              </div>
            </Divider>
            <p class="px-3">{{Report.topThree[0].professionalAnalysis}}</p>
          </SplitterPanel>
        </Splitter>
      </div>

      <div class="col-12 mb-5 surface-card shadow-1" v-if="!IsExporting">
        <Splitter layout="vertical" style="border:none">
          <SplitterPanel style="border-top: none;">
            <div style="text-align:center" class="p-3 my-0">
              <Badge :value="Report.topThree[1].categoryName" :style="{'background-color':GetBackGroundColor(1), 'color':'white'}" size="large"></Badge>
              <apexchart type="radialBar" height="175" :options="SetGaugeOptions(GetBackGroundColor(1) ,Report.topThree[0].categoryPercentageScore, Report.topThree[1].categoryName)" :series="GetSeries(Report.topThree[1].categoryPercentageScore)" :key="10"></apexchart>
            </div>
            <p class="px-3">{{Report.topThree[1].categoryDescription}}</p>
            <Divider align="center">
              <div class="inline-flex align-items-center">
                <i class="pi pi-briefcase mr-2" style="font-size: 1.5rem"></i>
                <b style="font-size: 1.5rem">Professional Expression</b>
              </div>
            </Divider>
            <p class="px-3">{{Report.topThree[1].professionalAnalysis}}</p>
          </SplitterPanel>
        </Splitter>
      </div>

      <div class="col-12 mb-5 surface-card shadow-1" v-if="!IsExporting">
        <Splitter layout="vertical" style="border:none">
          <SplitterPanel style="border-top: none;">
            <div style="text-align:center" class="p-3 my-0">
              <Badge :value="Report.topThree[2].categoryName" :style="{'background-color':GetBackGroundColor(2), 'color':'white'}" size="large"></Badge>
              <apexchart type="radialBar" height="175" :options="SetGaugeOptions(GetBackGroundColor(2) ,Report.topThree[2].categoryPercentageScore, Report.topThree[2].categoryName)" :series="GetSeries(Report.topThree[2].categoryPercentageScore)" :key="10"></apexchart>
            </div>
            <p class="px-3">{{Report.topThree[2].categoryDescription}}</p>
            <Divider align="center">
              <div class="inline-flex align-items-center">
                <i class="pi pi-briefcase mr-2" style="font-size: 1.5rem"></i>
                <b style="font-size: 1.5rem">Professional Expression</b>
              </div>
            </Divider>
            <p class="px-3">{{Report.topThree[2].professionalAnalysis}}</p>
          </SplitterPanel>
        </Splitter>
      </div>

      <div class="container mt-5" v-if="Rpt.topThree.length != 0 && !IsExporting ">
        <Divider align="center">
          <div class="inline-flex align-items-center mt-5">
            <i class="pi pi-chart-bar mr-2" style="font-size: 1.5rem"></i>
            <b style="font-size: 1.0rem">My Remaining Power Tools  </b>
          </div>
        </Divider>

        <div class="container my-5" style="margin-top:0;" v-if="Report">
          <div class="row scalein animation-duration-500 my" v-for="(item, index) in Report.reportItems" :key="index">
            <div class="col-12 surface-card shadow-1" style="margin-top:0; margin-bottom:0">

              <Splitter layout="vertical" style="border:none">
                <SplitterPanel style="border-top: none;">
                  <div style="text-align:center" class="p-3 my-0">
                    <Badge :value="item.categoryName" :style="{'background-color':'#4d5970', 'color':'white'}" size="large"></Badge>
                    <apexchart type="radialBar" height="150" :options="SetGaugeOptions('#4d5970' ,item.categoryPercentageScore, item.categoryName)" :series="GetSeries(item.categoryPercentageScore)"></apexchart>
                  </div>
                  <p class="px-3">{{item.categoryDescription}}</p>
                  <Divider align="center">
                    <div class="inline-flex align-items-center">
                      <i class="pi pi-briefcase mr-2" style="font-size: 1.5rem"></i>
                      <b style="font-size: 1.5rem">Professional Expression</b>
                    </div>
                  </Divider>
                  <p class="px-3">{{item.professionalAnalysis}}</p>
                </SplitterPanel>
              </Splitter>
            </div>

            <Divider align="center" v-if="index != Report.reportItems.length - 1">
              <div class="inline-flex align-items-center my-3">
                <i class="pi pi-bolt mr-2" style="font-size: 1.5rem; color: #214287"></i>
              </div>
            </Divider>
          </div>
        </div>
      </div>
      <div class="grid h-screen" v-if="IsExporting">
        <div class="col-12 flex justify-content-center align-items-center">
          <LoadingSpinner label="Exporting Your Report" />
        </div>
      </div>
    </Panel>
  </div>
  <ScrollTop />
</template>

<script>
  /* eslint-disable vue/no-unused-components */
  /* eslint-disable no-debugger, no-unused-vars*/
  import VueApexCharts from "vue3-apexcharts";
  import LoadingSpinner from '@/components/LoadingSpinner.vue';

  export default {
    name: 'PdfReport',
    props: ['AssessorEmail', 'AssessmentId', 'AssessmentDetails', 'Report', 'LogoUrl', 'ShowEmailedToBanner'],
    components: {
      apexchart: VueApexCharts,
      LoadingSpinner
    },
    data: () => ({
      TopThreeColors: ["#FFA726", "#FF7043", "#5C6BC0"],
      Rpt: null,
      IsExporting: false,
      ShowEmailedBanner:false
    }),
    created() {
      this.Rpt = this.$props.Report

      if (this.$props.ShowEmailedToBanner)
      {
        if (this.$props.ShowEmailedToBanner == true) {
          this.ShowEmailedBanner = true;
        }
        else {
          this.ShowEmailedBanner = false;
        }
      }
      else
      {
        this.ShowEmailedBanner = true;
      }
     
      var self = this;
      setTimeout(() => {
      self.$refs.successmsg.close();
      }, 5000)
    },
    mounted() {
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'));
      });
    },
    methods: {
      GetBackGroundColor(index) {
        return this.TopThreeColors[index];
      },

      GetWidth(number) {
        return number + '%'
      },
      SetGaugeOptions(color, val, description) {
        var options = {
          chart: {
            height: 350,
            type: 'radialBar',
            offsetY: -10,
            colors: [color],
          },
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 135,
              dataLabels: {
                name: {
                  fontSize: '16px',
                  color: color,
                  offsetY: 120
                },
                value: {
                  offsetY: 76,
                  fontSize: '22px',
                  color: undefined,
                  formatter: function (val) {
                    return val + "%";
                  }
                }
              }
            }
          },
          style: {
            colors: [color]
          },

          fill: {
            colors: [color],
            gradient: {
              shade: 'dark',
              shadeIntensity: 0.15,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 50, 80, 100]
            },
          },
          stroke: {
            dashArray: 4
          },
          labels: [``],
          
        };
        return options;
      },
      GetSeries(Number) {
        return [Number]
      },
      GetPercentageColorText(number) {
        var appendTxt = 'text-'
        var prependTxt = ' font-medium';
        var classColor = '';

        if (number <= 50)
          classColor = 'red-500'
        if (number <= 70 && number > 50)
          classColor = "yellow-500"
        if (number <= 80 && number > 70)
          classColor = "green-300"
        if (number <= 90 && number > 80)
          classColor = "green-400"
        if (number <= 100 && number > 90)
          classColor = "green-500"

        return `${appendTxt}${classColor} ${prependTxt}`;
      },


      GetPercentageColor(number) {
        var appendTxt = 'bg-'
        var prependTxt = 'h-full font-medium';
        var classColor = '';

        if (number <= 50)
          classColor = 'red-500'
        if (number <= 70 && number > 50)
          classColor = "yellow-500"
        if (number <= 80 && number > 70)
          classColor = "green-300"
        if (number <= 90 && number > 80)
          classColor = "green-400"
        if (number <= 100 && number > 90)
          classColor = "green-500"

        return `${appendTxt}${classColor} ${prependTxt}`;
      },
      GetGaugeColor(number) {
        var appendTxt = 'bg-'
        var prependTxt = 'h-full';
        var classColor = '';

        if (number <= 50)
          classColor = '#EF5350'
        if (number <= 70 && number > 50)
          classColor = "#F9A825"
        if (number <= 80 && number > 70)
          classColor = "#A5D6A7"
        if (number <= 90 && number > 80)
          classColor = "#81C784"
        if (number <= 100 && number > 90)
          classColor = "#43A047"

        return `${classColor}`;
      },
       generateReport() {
       
        this.IsExporting = true;

        var self = this;

        this.$http.post('/Assessment/GeneratePDF', { ReportItems: this.Report.reportItems, TopThree: this.Report.topThree }, {
          responseType: 'arraybuffer',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
          }
        }).then(resp => {

          self.IsExporting = false;
          /*   const url = window.URL.createObjectURL(new Blob([resp.data]));*/
          var file = new Blob([resp.data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = fileURL;
          link.setAttribute('target', '_blank');
          link.setAttribute('download', 'Power_Tools_Assessment_Report.pdf');
          document.body.appendChild(link);
          link.click()
        });
      },
    }
  };
</script>



